<template>
  <div class="form-group-wrapper">
    <!-- USER DETAILS -->
    <h3 class="text-lg font-semibold mb-4">
      {{ $t("ELIXIO_PAY.USER_DETAILS") }}
    </h3>
    <div class="form-group-wrapper-item">
      <base-input
        :label="$t('ELIXIO_PAY.FIRSTNAME')"
        v-model="form.userDetails.firstName"
      />
    </div>
    <div class="form-group-wrapper-item">
      <base-input
        :label="$t('ELIXIO_PAY.LASTNAME')"
        v-model="form.userDetails.lastName"
      />
    </div>
    <div class="form-group-wrapper-item">
      <base-input
        :label="$t('COMMON.EMAIL')"
        v-model="form.userDetails.email"
      />
    </div>
    <div class="form-group-wrapper-item">
      <base-input
        :label="$t('COMMON.PHONE')"
        v-model="form.userDetails.phone"
      />
    </div>

    <!-- SHIPPING ADDRESS -->
    <h3 class="text-lg font-semibold mb-4">
      {{ $t("ELIXIO_PAY.SHIPPING_ADDRESS") }}
    </h3>
    <div class="form-group-wrapper-item">
      <base-input
        :label="$t('COMMON.ADDRESS')"
        v-model="form.shippingAddress.address"
      />
    </div>
    <div class="form-group-wrapper-item">
      <base-input
        :label="$t('COMMON.CITY')"
        v-model="form.shippingAddress.city"
      />
    </div>
    <div class="form-group-wrapper-item">
      <base-input
        :label="$t('COMMON.STATE')"
        v-model="form.shippingAddress.state"
      />
    </div>
    <div class="form-group-wrapper-item">
      <base-input
        :label="$t('COMMON.ZIP')"
        v-model="form.shippingAddress.zipcode"
      />
    </div>
    <div class="form-group-wrapper-item">
      <base-input
        :label="$t('COMMON.COUNTRY')"
        v-model="form.shippingAddress.country"
      />
    </div>

    <!-- BILLING ADDRESS -->
    <div class="justify-between mb-4">
      <h3 class="text-lg font-semibold">
        {{ $t("ELIXIO_PAY.BILLING_ADDRESS") }}
      </h3>
      <el-checkbox v-model="sameAsShipping" @change="syncBillingWithShipping">
        {{ $t("ELIXIO_PAY.SAME_AS_SHIPPING") }}
      </el-checkbox>
    </div>

    <div class="form-group-wrapper-item">
      <base-input
        :label="$t('COMMON.ADDRESS')"
        v-model="form.billingAddress.address"
      />
    </div>
    <div class="form-group-wrapper-item">
      <base-input
        :label="$t('COMMON.CITY')"
        v-model="form.billingAddress.city"
      />
    </div>
    <div class="form-group-wrapper-item">
      <base-input
        :label="$t('COMMON.STATE')"
        v-model="form.billingAddress.state"
      />
    </div>
    <div class="form-group-wrapper-item">
      <base-input
        :label="$t('COMMON.ZIP')"
        v-model="form.billingAddress.zipcode"
      />
    </div>
    <div class="form-group-wrapper-item">
      <base-input
        :label="$t('COMMON.COUNTRY')"
        v-model="form.billingAddress.country"
      />
    </div>
    <div class="form-group-wrapper-item">
      <base-input
        :label="$t('COMMON.EMAIL')"
        v-model="form.billingAddress.email"
      />
    </div>
  </div>
</template>

<script>
import { Checkbox } from "element-ui";
export default {
  name: "NuveiUserForm",

  components: {
    [Checkbox.name]: Checkbox,
  },

  props: {
    model: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      sameAsShipping: false,
      form: {
        userDetails: {
          firstName: "",
          lastName: "",
          email: "",
          phone: "",
        },
        shippingAddress: {
          address: "",
          city: "",
          state: "",
          zipcode: "",
          country: "",
        },
        billingAddress: {
          address: "",
          city: "",
          state: "",
          zipcode: "",
          country: "",
          email: "",
        },
      },
    };
  },

  watch: {
    model: {
      immediate: true,
      handler(val) {
        if (val) this.fillFromCustomer(val);
      },
    },
  },

  methods: {
    fillFromCustomer(customer) {
      // USER DETAILS
      this.form.userDetails = {
        firstName: customer.firstname,
        lastName: customer.lastname,
        email: customer.email,
        phone: customer.phone,
      };

      // SHIPPING ADDRESS
      this.form.shippingAddress = {
        address: customer.address || "",
        city: customer.city || "",
        state: customer.state || "",
        zipcode: customer.zipcode || "",
        country: customer.country || "",
      };

      // BILLING ADDRESS
      this.form.billingAddress = {
        address: customer.billing_address || "",
        city: customer.billing_city || "",
        state: customer.billing_state || "",
        zipcode: customer.billing_zipcode || "",
        country: customer.billing_country || "",
        email: customer.billing_email || customer.email || "",
      };
    },

    syncBillingWithShipping(checked) {
      if (checked) {
        this.form.billingAddress = { ...this.form.shippingAddress };
      }
    },
  },
};
</script>

<style scoped>
.nuvei-user-form {
  width: 100%;
}
</style>
